import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUpload } from '../contexts/UploadContext';

// Shown instead of starting an upload that would break the certificate allowance.
const UploadLimitDialog: React.FC = () => {
  const { block, dismissBlock } = useUpload();
  const navigate = useNavigate();

  return (
    <Dialog open={Boolean(block)} onClose={dismissBlock} maxWidth="xs" fullWidth>
      <DialogTitle>{block?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{block?.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={dismissBlock}>OK</Button>
        {block?.showPlanLink && (
          <Button variant="contained" onClick={() => { dismissBlock(); navigate('/profile'); }}>
            Buy a plan
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default UploadLimitDialog;
